import angular from 'angular';

import ScrollContainerDirective, { selector } from './scroll-container.directive';

export default angular
    .module('application.directive.scroll-container', [])
    .directive(selector, ScrollContainerDirective);



// WEBPACK FOOTER //
// ./src/application/directive/scroll-container/index.js